import getParameter from "../../util/getParameter";
import Debounce from "../../util/debounce";
import Overlay from "../../util/overlay";
import UTM from "../../util/utm-tracking";

function Consultation() {

  window.consultation_status = "rendering";
  window.confirmOverlay = new Overlay({
      trigger: document.querySelectorAll('.overlay__button--overlay-confirm')
  });

  this.slideNextEvent = new CustomEvent("survey-slide-next");
  this.slidePrevEvent = new CustomEvent("survey-slide-prev");

  this.saveError = false;

  this.mode = "live";

  this.nonce = window.nonce;

  this.loadingEl = document.querySelector('.consultation__loading');

  this.pagesEl = document.querySelector('.consultation__pages');
  this.pagesElMover = this.pagesEl.querySelector('.mover');
  this.prevBtn = null;

  this.user_id = null;
  this.user_validated = false;

  this.last_rendered_question = null;

  this.new_password_strength = null;

  this.sent_data = {};
  this.send_data = {};
  this.data = {};

  this.truth_table = null;
  this.scores = null;
  this.reports = null;
  this.reports_truth_table = null;
  this.various_texts = null;

  this.truth_table_json = "../truth_table.json";
  this.scores_json = "../scores.json";
  this.reports_json = "../d_and_l_reports.json";
  this.reports_truth_table_json = "../reports_truthtable.json";
  this.various_texts_json = "../various_texts.json";

  // if (this.mode == "test") {
  //   this.truth_table_json = "../test_truth_table.json";
  //   this.scores_json = "../test_scores.json";
  // }

  this.cachedOtherGoalsThatWereCut = [];
  this.MaxCapsules = 4;

  var that = this;

  if (typeof (window.SurveyJS) == 'object') {
    that.loadResources(window.SurveyJS);
  }
  else {
    document.addEventListener("survey-init", function () {
      that.loadResources(window.SurveyJS);
    });
  }

  document.addEventListener("survey-slide-next", function () {
    that.slideNext();
  });

  document.addEventListener("survey-slide-prev", function () {
    that.slidePrev();
  });

  var setChoicesHeightFunction = Debounce(function () {
    that.setChoicesHeight();
  }, 100);

  window.addEventListener('resize', setChoicesHeightFunction, false);

  window.addEventListener('beforeunload', function(e) {
    console.log('leave-survey');
    dataLayer.push({
      'event': 'consultation-event',
      'customEventCategory': 'consultation',
      'customEventAction': 'leave-survey',
      'customEventLabel': that.last_rendered_question,
      'customEventValue': null
    });
  });

}

Consultation.prototype.loadResources = function (survey) {

  console.log('loadResources');

  if (typeof window.theme_version != "undefined" && typeof window.consultation_files != "undefined") {
    this.truth_table_json = window.consultation_files.truth_table + "?ver=" + window.theme_version;
    this.scores_json = window.consultation_files.scores + "?ver=" + window.theme_version;
    this.reports_json = window.consultation_files.reports + "?ver=" +  window.theme_version;
    this.reports_truth_table_json = window.consultation_files.reports_truth_table + "?ver=" + window.theme_version;
    this.various_texts_json = window.consultation_files.various_texts + "?ver=" + window.theme_version;
  }

  var that = this;
  jQuery.getJSON(that.truth_table_json, function (truth_table_json) {
    that.truth_table = truth_table_json;
    jQuery.getJSON(that.scores_json, function (scores_json) {
      that.scores = scores_json;
      jQuery.getJSON(that.reports_json, function (reports_json) {
        that.reports = reports_json;
        jQuery.getJSON(that.reports_truth_table_json, function (reports_truth_table_json) {
          that.reports_truth_table = reports_truth_table_json;
          jQuery.getJSON(that.various_texts_json, function (various_texts_json) {
            that.various_texts = various_texts_json;
            jQuery.each(survey.getAllQuestions(), function(i, q) {
              if (
                typeof (q.requiredErrorText) != "undefined"
                && q.requiredErrorText == ""
                && that.various_texts['ERROR_EMPTY_ANSWER']
              )
              {
                q.requiredErrorText = that.various_texts['ERROR_EMPTY_ANSWER'];
              }
            });
            that.loadSurvey(survey);
          });
        });
      });
    });
  });

}

Consultation.prototype.loadSurvey = function (survey) {

  // console.log('loadSurvey');

  var that = this;

  survey.css = {
    navigationButton: "button btn-lg",
    pageTitle: "page-title"
  };

  that.data.name = "";

  survey.showQuestionNumbers = "off";
  survey.requiredText = "";
  survey.goNextPageAutomatic = false;
  survey.focusFirstQuestionAutomatic = false;
  survey.clearInvisibleValues = 'onHidden'; // clears values from answers if they are hidden
  survey.showNavigationButtons = true;
  survey.showProgressBar = "top";
  survey.pagePrevText = this.various_texts['BUTTON_PREVIOUS'];
  survey.pageNextText = this.various_texts['BUTTON_NEXT'];
  survey.completeText = this.various_texts['BUTTON_COMPLETE'];
  survey.onComplete.add(function (survey, options) { that.onComplete(survey, options) });
  survey.onCurrentPageChanging.add(function (survey, options) { that.onCurrentPageChanging(survey, options) });
  survey.onValueChanged.add(function (survey, options) { that.onValueChanged(survey, options) });
  survey.onValidateQuestion.add(function (survey, options) { that.onValidateQuestion(survey, options) });
  survey.onUpdateQuestionCssClasses.add(function (survey, options) { that.onUpdateQuestionCssClasses(survey, options) });
  survey.onAfterRenderPage.add(function (survey, options) { that.onAfterRenderPage(survey, options) });
  survey.onAfterRenderQuestion.add(function (survey, options) { that.onAfterRenderQuestion(survey, options) });
  survey.onAfterRenderSurvey.add(function (survey, options) { that.onAfterRenderSurvey(survey, options) });

  var ls = that.checkLocalStorage();
  var consultation_id = null;

  if (ls) { // use local storage

    console.log('use local storage');

    // console.log('load via local storage');

    // LOAD SURVEY VIA LOCAL STORAGE

    if (typeof ls.data.name != 'undefined') {
      window.name = ls.data.name;
    } else if (typeof window.name != 'undefined') {
      ls.data.name = window.name;
    }

    if (typeof ls.data.email != 'undefined') {
      window.email = ls.data.email;
    } else if (typeof window.email != 'undefined') {
      ls.data.email = window.email;
    }

    if (typeof ls.data.consultation_id != 'undefined') {
      window.consultation_id = ls.data.consultation_id;
    }

    if (typeof window.user_id != 'undefined') {
      that.user_validated = true;
      ls.data.user_id = window.user_id;
    }

    survey.data = ls.data;
    that.data = ls.data;
    that.send_data = ls.send_data;
    survey.setValue('hasExistingAccount', window.hasExistingAccount);
    survey.setValue('isUserLoggedIn', window.isUserLoggedIn);
    // console.log('load page', ls.page);
    survey.currentPageNo = parseInt(ls.page);
    survey.render('surveyContainer');
    survey.currentPageNo = parseInt(ls.page) + 1;
    setTimeout(function () {
      that.hideLoading();
    }, 1000);

    dataLayer.push({
      'event': 'consultation-event',
      'customEventCategory': 'consultation',
      'customEventAction': 'resume-consultation',
      'customEventLabel': null,
      'customEventValue': null
    });

  }
  else {  // don't use local storage 

    console.log('do not use local storage');

    if (!consultation_id) {
      consultation_id = getParameter("id") || window.consultation_id;
    }

    if (getParameter('restart')) {
      consultation_id = null;
    }

    if (typeof consultation_id !== 'undefined' && !isNaN(parseFloat(consultation_id))) {
      // LOAD SURVEY VIA DATABASE
      // console.log('load via database');
      consultation_id = parseFloat(consultation_id);

      jQuery.ajax({
        type: "POST",
        url: "/wp-json/process_consultation/v1/get",
        data: { id: consultation_id, type: window.consultation_type },
        beforeSend: function (xhr) {
          // Here we set a header 'X-WP-Nonce' with the nonce
          xhr.setRequestHeader('X-WP-Nonce', that.nonce);
        },
      })
        .done(function (response) {
          if (response.status == "success") {
            var ev = new CustomEvent("survey-data-load");
            document.dispatchEvent(ev);
            that.data = response.data;
            that.data.user_id = response.user_id;
            that.data.consultation_id = consultation_id;
            that.data.consultation_type = response.consultation_type;
            that.data.consultation_type_slug = consultation_type_slug;
            that.data.email = response.data.email;
            that.user_validated = true;
            survey.data = response.data;
            survey.currentPageNo = parseInt(response.data.currentPageNo) + 1;
          }
          else {
            if (typeof window.name != 'undefined') {
              that.data.name = window.name;
              that.data.email = window.email;
              that.data.user_id = window.user_id;
              that.user_validated = true;
              survey.data = { name: window.name, email: window.email };
            }
          }
          if (typeof window.name != 'undefined') {
            survey.setValue('name', window.name);
          }
          survey.setValue('hasExistingAccount', window.hasExistingAccount);
          survey.setValue('isUserLoggedIn', window.isUserLoggedIn);
          survey.render('surveyContainer');
          that.hideLoading();
        });

        dataLayer.push({
          'event': 'consultation-event',
          'customEventCategory': 'consultation',
          'customEventAction': 'resume-consultation',
          'customEventLabel': null,
          'customEventValue': null
        });

    }
    else {
      // LOAD NEW SURVEY
      // console.log('load new survey');
      if (typeof window.name != 'undefined') {
        that.data.name = window.name;
        that.data.email = window.email;
        that.data.user_id = window.user_id;
        that.data.consultation_type = window.consultation_type;
        that.data.consultation_type_slug = window.consultation_type_slug;
        that.user_validated = true;
        survey.data = { name: window.name, email: window.email };
      }
      survey.setValue('name', that.data.name);
      survey.setValue('hasExistingAccount', window.hasExistingAccount);
      survey.setValue('isUserLoggedIn', window.isUserLoggedIn);
      survey.render('surveyContainer');
      that.hideLoading();

      dataLayer.push({
        'event': 'consultation-event',
        'customEventCategory': 'consultation',
        'customEventAction': 'start-consultation',
        'customEventLabel': null,
        'customEventValue': null
      });
      
    }
  }

  // post id of consultation configuration
  survey.data.consultation_type = window.consultation_type;
  survey.data.consultation_type_slug = window.consultation_type_slug;

  jQuery(document).keypress(function (e) {

    var key = e.which;
    var question = survey.currentPage.questions[0];
    if (key == 13 && question.inputType == "text")  // the enter key code
    {
      if (e.target.name != "password" && e.target.name != "new_password") {
        survey.setValue(question.name, e.target.value);
      }
      jQuery('.sv_next_btn').click();
    }

  });

}

Consultation.prototype.checkLocalStorage = function () {

  var useLocalStorage = false,
    that = this;

  if (getParameter('restart')) {
    that.clearLocalStorage();
    return false;
  }

  var ls_type = localStorage.getItem('gp_consultation_type');
  // if the local storage doesn't match current consultation type (post ID of configuration), clear storage and start again
  if (parseInt(ls_type) != parseInt(window.consultation_type)) {
    that.clearLocalStorage();
    return false;
  }

  if (getParameter('id')) {
    return false;
  }

  if (typeof localStorage != 'undefined' && localStorage.getItem('gp_consultation_data') && localStorage.getItem('gp_consultation_page')) {
    var ls_data = JSON.parse(localStorage.getItem('gp_consultation_data'));
    var ls_send_data = JSON.parse(localStorage.getItem('gp_consultation_send_data'));
    var ls_page = localStorage.getItem('gp_consultation_page');

    if (typeof (ls_data.user_id) != 'undefined') {
      // console.log('ls.user_id is defined');
      if (typeof window.user_id != 'undefined') {
        // console.log('window.user_id is defined');
        if (ls_data.user_id == window.user_id) {
          // console.log('user_ids defined and match');
          useLocalStorage = true;
        }
        else {
          // console.log('user_ids do not match, clear');
          that.clearLocalStorage();
        }
      }
      else {
        // console.log('user logged out? clear');
        that.clearLocalStorage();
      }
    }
    else {
      // console.log('ls.user_id is undefined');
      if (typeof window.user_id != 'undefined') {
        // console.log('window.user_id is defined');
        // console.log('user ids do not match...started consultation before logging in...has now logged in, clear');
        that.clearLocalStorage();
      }
      else {
        // console.log('window.user_id is undefined');
        useLocalStorage = true;
      }
    }
  }

  if (useLocalStorage) {
    return {
      data: ls_data,
      send_data: ls_send_data,
      page: ls_page
    }
  }

  return false;

}

Consultation.prototype.clearLocalStorage = function () {
  localStorage.removeItem('gp_consultation_data');
  localStorage.removeItem('gp_consultation_send_data');
  localStorage.removeItem('gp_consultation_page');
  localStorage.removeItem('gp_consultation_type');
  document.cookie = "gp_consultation=progress;path=/;Max-Age=-99999999;";
}

Consultation.prototype.onUpdateQuestionCssClasses = function (survey, options) {

  var classes = options.cssClasses

  classes.mainRoot = "sv_qstn";

  if (options.question.getType() == "html") {
    classes.mainRoot = "sv_qstn sv_qstn--html";
  }

  if (typeof options.question.title != 'undefined') {

    if (typeof options.question.choices != 'undefined' && (options.question.choices.length == 2 || options.question.choices.length == 4)) {
      // Q15E1 is backwards compatible, marketing is new field name
      if (options.question.name == 'GettingToKnowYouQ15E1' || options.question.name == 'marketing') {
        classes.mainRoot = "sv_qstn sv_qstn--consent sv_qstn--2col";
      }
      else {
        classes.mainRoot = "sv_qstn sv_qstn--2col";
      }
    }
    else {
      if (options.question.name == 'GettingToKnowYouQ15E1' || options.question.name == 'marketing') {
        classes.mainRoot = "sv_qstn sv_qstn--consent";
      }
    }
  }

}

Consultation.prototype.onCurrentPageChanging = function (survey, options) {

  if (typeof survey.getValue('name') == 'undefined' || (survey.getValue('name') == "" && this.data.name != "")) {
    survey.setValue("name", this.data.name);
  }

  var surveyContainer = document.getElementById('surveyContainer');
  var slidePrevContainer = document.getElementById('slidePrevQuestionContainer');
  var slideNextContainer = document.getElementById('slideNextQuestionContainer');
  slideNextContainer.innerHTML = "";

  var slide = document.querySelector('#surveyContainer .sv_qstn');

  if (slide && window.consultation_status != "rendering") {

    var clone = slide.cloneNode(true);
    var cloneScrollTop = slide.scrollTop;

    var oldIndex = options.oldCurrentPage.visibleIndex;
    var newIndex = options.newCurrentPage.visibleIndex;

    if (oldIndex > newIndex) { // backwards
      slideNextContainer.innerHTML = "";
      slideNextContainer.appendChild(clone);
      document.dispatchEvent(this.slidePrevEvent);
      slideNextContainer.querySelector('.sv_qstn').scrollTop = cloneScrollTop;
    }
    else { // forwards
      slidePrevContainer.innerHTML = "";
      slidePrevContainer.appendChild(clone);
      document.dispatchEvent(this.slideNextEvent);
      slidePrevContainer.querySelector('.sv_qstn').scrollTop = cloneScrollTop;
    }

  }

  if (window.consultation_status == "rendering") {
    window.consultation_status = "idle";
  }

  this.checkPageTitle(options.oldCurrentPage, options.newCurrentPage, survey);

}

Consultation.prototype.onAfterRenderSurvey = function (survey, options) {

  var oldPage = {
    "title": "",
    "visibleIndex": -1
  }
  if (this.data.name == "") { // fix for first page bug if name not set
    survey.currentPageNo = 0;
  }
  else {
    window.consultation_status = "idle";
  }

  // dataLayer.push({
  //   'event': 'consultation-event',
  //   'customEventCategory': 'consultation',
  //   'customEventAction': 'render-survey',
  //   'customEventLabel': null,
  //   'customEventValue': null
  // });

  this.checkPageTitle(oldPage, options.survey.currentPage, survey);

}

Consultation.prototype.onAfterRenderPage = function (survey, options) {

  var thisPage = options.page.visibleIndex;

  if (options.page.visibleIndex > 0) {
    var prev_btn = document.querySelector('.sv_prev_btn');
    if (prev_btn) {
      prev_btn.style.display = "block";
    }
  }

  // disable the Next button while scrolling the slide
  let nextButton = jQuery('input.sv_next_btn');
  nextButton.prop('disabled', true);

  setTimeout(function () {
    nextButton.prop('disabled', false);
  }, 1000);

  if (options.page.maxTimeToFinish > 0 || options.page.visibleIndex == 0) {

    var transition_speed = 1000;
    var timeout = 1500 + transition_speed;

    if (options.page.maxTimeToFinish > 0) {
      timeout = parseFloat(options.page.maxTimeToFinish) * 1000 + transition_speed;
    }

    setTimeout(function () {
      if (thisPage == window.SurveyJS.currentPage.visibleIndex) { // if we haven't skipped through manually
        survey.nextPage();
      }
    }, timeout);
  }

  jQuery('#surveyContainer .sv_qstn fieldset').wrapInner("<div class='consultation__options'></div>");

  this.setChoicesHeight();
  this.fieldsetScrollListeners();

}

Consultation.prototype.onAfterRenderQuestion = function (survey, options) {

  this.last_rendered_question = options.question.name + " - " + options.question.title;

  if (options.question.name === 'name') {
      console.log('given name!');
    var name_input = document.querySelector('#surveyContainer .sv_qstn input[type="text"]');
    if (name_input) {
        name_input.autocomplete = 'given-name';
    }
  }

  // Q1E1 is backwards compatible, age is new field name
  else if (options.question.name == "GettingToKnowYouQ1E1" || options.question.name == "age") {
    var age_input = document.querySelector('#surveyContainer .sv_qstn input[type="text"]');
    if (age_input) {
        age_input.type = 'number';
    }
  }

  else if (options.question.name == "password") {
    if (survey.data.hasExistingAccount) {
      this.addPasswordField();
    }
    else {
      this.addNewPasswordField();
    }
  }
  if (options.question.getType() == "checkbox") {
    jQuery('#surveyContainer .alert').before('<span class="consultation__please-select-all">Please select all that apply.</span>');
  }
  if (options.question.getType() == "radiogroup") {
    if (typeof options.question.value == 'undefined' || options.question.value === null) {
      this.nextButtonVisibility(0);
    }
    else {
      // If they have already selected an answer and gone Back, show the Continue button as we don't want to force them to change answer.
      this.nextButtonVisibility(1);
    }
  }
  else {
    this.nextButtonVisibility(1);
  }

  if (typeof options.question.title != 'undefined') {
    dataLayer.push({
      'event': 'consultation-event',
      'customEventCategory': 'consultation',
      'customEventAction': 'load-question',
      'customEventLabel': options.question.title,
      'customEventValue': null
    });
  }

  var alertZone = document.querySelector('#surveyContainer .sv_qstn .alert');

  if (alertZone) {

    var observer = new MutationObserver(function () {
      jQuery('#surveyContainer .sv_qstn').animate({ scrollTop: 0 }, "fast");
    });

    observer.observe(alertZone, { childList: true });

  }

  if (typeof fbq !== 'undefined') {
    fbq('track', 'ViewContent', {
      source: 'vivewellnesspixel',
      step: survey.currentPageNo
    });
  }
  
}

Consultation.prototype.setChoicesHeight = function () {

  var choices = document.querySelectorAll('#surveyContainer .sv_qstn .radio label, #surveyContainer .sv_qstn .checkbox label');

  if (choices !== null) {
    var biggest_choice_height = 0;

    if (window.innerWidth >= 800) {

      for (var i = 0; i < choices.length; i++) {

        choices[i].style.height = 'auto';

        if (choices[i].offsetHeight > biggest_choice_height) {
          biggest_choice_height = choices[i].offsetHeight;
        }

      }

    }

    for (var i = 0; i < choices.length; i++) {

      if (window.innerWidth >= 800) {
        choices[i].style.height = biggest_choice_height + "px";
      }
      else {
        choices[i].style.height = 'auto';
      }

    }

  }
  
}

Consultation.prototype.onValueChanged = function (survey, options) {
  if (options.name != 'hasExistingAccount' && options.name != 'isUserLoggedIn' && options.name != 'name') {
    this.updateMaxCapsules(options);
    this.consoleLogCurrentState(survey, options);
    this.gotoNextIfPickOneQuestion(survey, options);
  }
  if (options.name === 'email') {
    var value = options.value;
    if (value) {
      // strip out any spaces from email address
      survey.setValue('email', value.replace(/\s/g, ""));
    }
  }
}

Consultation.prototype.ucwords = function (str) {
  return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
    return $1.toUpperCase();
  });
}

Consultation.prototype.onValidateQuestion = function (survey, options) {

  this.hideDynamicAnswers(survey, options);

  var that = this;

  if (options.name == 'age') {
    if (options.value < 18) {
      options.error = this.various_texts['AGE_TOO_YOUNG'];
      return;
    }
    if (options.value > 110) {
      options.error = this.various_texts['AGE_TOO_OLD'];
      return;
    }
  }

  if (options.name == "email") {
    this.validateUser(survey, options);
  }
  else if (options.name == "password") {
    this.validateUser(survey, options);
  }
  else {
    if (options.name == 'name') {
      if (options.value != "") {
        var filteredNameLowercase = options.value.toLowerCase();
		    survey.setValue("name", this.ucwords(filteredNameLowercase));
      }
    }
    this.checkForDataToSave(survey, options);
  }

}

Consultation.prototype.onComplete = function (survey, options) {

  this.last_rendered_question = 'loading-results';
  // console.log('onComplete');
  var that = this;

  dataLayer.push({
    'event': 'consultation-event',
    'customEventCategory': 'consultation',
    'customEventAction': 'complete',
    'customEventLabel': that.last_rendered_question,
    'customEventValue': null
  });

  that.changeLoadingText('Analysing your Results');
  that.showLoading();
  that.data.results = that.surveyCompleteProcessAnswers(survey);
  // console.log(that.data.results);
  that.data.completed_at = new Date().getTime();

  const utm = new UTM();
  const utm_data = utm.getData();
  if (utm_data) {
    that.data.utm = utm_data;
  }

  jQuery.ajax({
    type: "POST",
    url: "/wp-json/process_consultation/v1/complete",
    data: { 'data': that.data, 'send_data': that.send_data },
    beforeSend: function (xhr) {
      // Here we set a header 'X-WP-Nonce' with the nonce
      xhr.setRequestHeader('X-WP-Nonce', that.nonce);
    },
  })
  .done(function (response) {
    if (response.status == "success") {
      that.changeLoadingText('Checking the Research');
      setTimeout(function () {
        that.changeLoadingText('Building your Pack');
        setTimeout(function () {
          // clear local data when consultation finished
          localStorage.removeItem('gp_consultation_data');
          localStorage.removeItem('gp_consultation_send_data');
          localStorage.removeItem('gp_consultation_page');
          localStorage.removeItem('gp_utm');
          document.cookie = "gp_consultation=complete;path=/;Max-Age=-99999999;";
          this.last_rendered_question = "redirect-to-pack";
          window.location = window.productsLoadConsultation.replace('%consultation_id%', response.consultation_id);
        }, 500);
      }, 500);
    }
    else {
      alert('An error occurred. Please refresh the page.');
    }
  });

}

export default Consultation;



// WEBPACK FOOTER //
// ./js/components/consultation/load.js